// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"DietPop_ConfirmationPop__5LbFy","modalBody":"DietPop_modalBody__hFEfA"};